import { FormGroup } from "@angular/forms";
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from "@angular/animations";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";

import { DataGridComponent } from "../data-grid/data-grid.component";
import { Store } from "@ngrx/store";
import { QueryStates } from "../query.reducer";
import * as actions from "./../query.actions";
import { ModalDirective } from "ngx-bootstrap/modal";
import { log } from "console";
import { QueryService } from "../query.service";
import { DataGridService } from "../data-grid/data-grid.service";

declare var pg: any;

@Component({
  selector: "app-options",
  templateUrl: "./options.component.html",
  styleUrls: ["./options.component.scss"],
  animations: [
    trigger("changeState", [
      state("true", style({ opacity: 1 })),
      state("false", style({ opacity: 0, display: "none" })),
      transition("true=>false", [animate("0.20s ease-out")]),
      transition("false=>true", [animate("0.30s ease-in")]),
    ]),
  ],
})
export class OptionsComponent implements OnInit, OnDestroy {
  // Atributos de configuracion del componente (parametros de entrada) . Se envian desde el componente Query / Subquery
  stateTemporl = "false";
  groupable = false;
  val: boolean = false;
  escenarios;
  currentEscenario;
  basedonid: string;
  queryParam;
  @Input() submitted: boolean;
  @Input() queryid: string;
  @Input() form: FormGroup;
  @Input() readonly = false;
  @Input() execute = true;
  @Input() options = true;
  @Input() export = true;
  @Input() reportlocation = null;

  @Input() group = true;
  @Input() splitpanel = true;
  @Input() graphreport = "N";
  @Input() opctionsConfig = { exportxlsflag: "Y", exportpdfflag: "Y" };

  @Input() printlabel = false;
  @Input() queryconfigtype: String;
  @Input() showgrid = true;
  @Input() executeQueryOnProcess: boolean;
  @Input() dataGridComponent: DataGridComponent;

  @Input() showScenarios: string;
  @Input() showArgumentos: string;
  valJasper: boolean = false;

  /// estados
  splitpanelState = false;

  // Eventos de salida hacia el componente padre (query / Subquery)
  @Output() onEventSplit = new EventEmitter<boolean>();
  @Output() onEventSubmit = new EventEmitter<boolean>();
  @Output() onEventSubmitJasperXls = new EventEmitter<boolean>();
  @Output() onEventSubmitJasperPdf = new EventEmitter<boolean>();

  @Output() onEventShowScenarios = new EventEmitter<boolean>();
  @Output() onEventShowArgumentos = new EventEmitter<boolean>();

  @ViewChild("mdOptions") mdOptions: ModalDirective;
  currentOption: any;

  constructor(
    public toastr: ToastrService,
    private store: Store<QueryStates>,
    private activatedRoute: ActivatedRoute,
    private queryService: QueryService,
  ) {}

  ngOnInit() {
    this.queryParam = this.activatedRoute.snapshot.params["queryid"];
    this.basedonid = this.activatedRoute.snapshot.params["basedonid"];
    this.queryService
      .getScenarios(this.queryParam, this.basedonid)
      .subscribe((responseScenario: any[]) => {
        this.escenarios = responseScenario;
        console.log(this.escenarios);
        
      });
    // console.log(this.printlabel);
    // console.log("this.reportlocation: ", this.reportlocation);
    // console.log('Current Type Query: ' , this.queryconfigtype)
  }

  onCancelModal() {
    this.mdOptions.hide();
  }

  onOpenModal() {
    this.currentOption = JSON.parse(sessionStorage.getItem("currentoption"));
    // console.log("this.reportlocation :", this.reportlocation);
    this.mdOptions.show();
  }

  showButton(array) {
    this.currentEscenario = array.find(
      (escenario) =>
        escenario.queryId === this.queryid
    );
    this.printLabel = this.currentEscenario.printLabel;

    console.log(this.currentEscenario, "escenario");
  }

  // Evento general de plantilla
  maximize(): void {
    pg.setFullScreen(document.querySelector("html"));
  }
  ngOnDestroy() {}
  ///////
  // Eventos asociados al componente Grid Data
  onSubmit() {
    /// boton ejecutar
    // console.log('Informacion del formulario desde Comp. Opciones' , this.form )
    // console.log("this.reportlocation :", this.reportlocation);
    if (this.valFormValidArgs()) {
      this.store.dispatch(
        actions.setProcessState({ stateProcess: "Valid", options: {} })
      );
      this.val = true;
    } else {
      this.store.dispatch(
        actions.setProcessState({ stateProcess: "Invalid", options: {} })
      );
      this.val = false;
    }
    this.showButton(this.escenarios);
    

    // implementar cambio de estado con redux
    // this.onEventSubmit.emit(this.form.valid);
  }

  onSubmitSpecial() {
    /// boton ejecutar exportacion especial
    // console.log('Informacion del formulario desde Comp. Opciones' , this.form )
    if (this.valFormValidArgs()) {
      this.store.dispatch(
        actions.setProcessState({ stateProcess: "Export Special", options: {} })
      );
      this.val = true;
    } else {
      this.store.dispatch(
        actions.setProcessState({ stateProcess: "Invalid", options: {} })
      );
      this.val = false;
    }
    // this.showButton(this.escenarios);
  }

  onPrintLabels() {
    if (this.valFormValidArgs()) {
      this.store.dispatch(
        actions.setProcessState({ stateProcess: "Print Labels", options: {} })
      );
    } else {
      this.store.dispatch(
        actions.setProcessState({ stateProcess: "Invalid", options: {} })
      );
    }
  }

  onSubmitReportsOrMacro() {
    /// boton ejecutar exportacion especial
    // console.log('Informacion del formulario desde Comp. Opciones' , this.form )
    if (this.valFormValidArgs()) {
      this.store.dispatch(
        actions.setProcessState({ stateProcess: "Export Report", options: {} })
      );
      this.val = true;
    } else {
      this.store.dispatch(
        actions.setProcessState({ stateProcess: "Invalid", options: {} })
      );
      this.val = false;
    }
  }

  onSubmitGrafico() {
    /// boton ejecutar exportacion Grafico
    if (this.valFormValidArgs()) {
      this.store.dispatch(
        actions.setProcessState({ stateProcess: "Export Grafico", options: {} })
      );
      this.val = true;
    } else {
      this.store.dispatch(
        actions.setProcessState({ stateProcess: "Invalid", options: {} })
      );
      this.val = false;
    }
  }

  setSplitPanel() {
    this.splitpanelState = !this.splitpanelState;
    // this.store.dispatch(actions.setSplitPageState({split: this.splitpanelState}));
    // this.onEventSplit.emit();
    this.openPage({});
  }

  setGroupable() {
    // this.groupable = !this.groupable;
    // this.dataGridComponent.groupable = this.groupable;
    this.toastr.info("opcion agrupamiento de grilla");
  }

  showHideGraph() {
    // this.dataGridComponent.showHideGraph();
    this.toastr.info("opcion visualizacion de grafica");
  }
  ///////
  // eventos Etiqueta
  printLabel() {
    this.toastr.info("Ejecucion servicio de impresion de etiquetas.");
  }
  ///////
  ///////
  // Opciones OnlyJasper
  onSubmitJasperXls() {
    if (this.valFormValidArgs()) {
      this.onEventSubmitJasperXls.emit(this.form.valid);
      this.val = true;
    } else {
      this.store.dispatch(
        actions.setProcessState({ stateProcess: "Invalid", options: {} })
      );
      this.val = false;
    }
  }

  valMacros() {
    if (this.queryid === "RepBiotecnologiaCombinado") {
      return false;
    } else if (this.queryid === "HISTORICO DETALLE SUBMISSION") {
      return false;
    } else {
      return true;
    }
  }

  onSubmitJasperPdf() {
    if (this.valFormValidArgs()) {
      this.onEventSubmitJasperPdf.emit(this.form.valid);
      this.val = true;
    } else {
      this.store.dispatch(
        actions.setProcessState({ stateProcess: "Invalid", options: {} })
      );
      this.val = false;
    }
  }
  ///////

  onShowScenarios() {
    this.onEventShowScenarios.emit(
      this.showScenarios === "true" ? true : false
    );
  }
  ///////

  onShowArgumentos() {
    console.log("Controles Formulario", this.form.controls);
    this.onEventShowArgumentos.emit(
      this.showArgumentos === "true" ? true : false
    );
  }
  ///////

  valFormValidArgs() {
    // Valida si el formulario con los argumentos es valido y emite mensaje
    if (!this.form.valid) {
      this.toastr.warning(
        "Existen argumentos requeridos no ingresados.",
        "Validación Argumentos"
      );
      return false;
    }
    return true;
  }

  /// codigo repetido
  openPage(options: any) {
    // https://www.oodlestechnologies.com/blogs/Open-popup-window-with-http-POST-data-Javascript/
    // query/subquery/ReporteRequest/RFX3B3B500000098 ,  TITULO
    // const popup = window.open(`/#/query/subquery/${queryid}/${basedonid}/${queryColumnId}/${value}`, value,
    //  'toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=0,
    // resizable=0,width=screen.width,height=screen.height,top=100px,left=100px')

    // var myWindow =  window.open("", "_blank", "width=200,height=100", false);
    // myWindow.document.write("<p>This is 'MsgWindow'. I am 200px wide and 100px tall!</p>   Last name: <input type='text' name='lname' value='Remberto'>");
    const nameWindow = JSON.stringify({
      idkey: `ventana:` + new Date().toString(),
      data: { id: 123 }, // this.arguments
    });

    console.log(nameWindow);
    let screenWidth = window.innerWidth * 0.8; /// 80%
    let screenHeight = window.innerHeight * 0.8; /// 80%

    let popup = window.open(
      `/#/queries`,
      nameWindow,
      `toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=yes,width=${screenWidth},height=700, left=200`,
      false
    );
  }

  onVewPanelGraphic() {
    this.store.dispatch(
      actions.setProcessState({
        stateProcess: "Vew Panel Graphic",
        options: {},
      })
    );
  }
}
